import face from '../img/face.png';
import fondo1 from '../img/fondo1.jpg';
import fondo2 from '../img/fondo2.png';
import fundadoras from '../img/fundadoras.png';
import hatha from '../img/hatha.png';
import hatha_yoga from '../img/hatha_yoga.png';
import hero_image from '../img/hero-image.jpg';
import hero_image_png from '../img/hero-image.png';
import hero_image2 from '../img/hero-image2.PNG';
import instag from '../img/instag.png';
import kundalini from '../img/kundalini.png';
import kundalini2 from '../img/kundalini2.PNG';
import logo from '../img/logo.png';
import maria from '../img/maria.JPG';
import maria_png from '../img/maria.png';
import marly from '../img/marly.JPG';
import marly_png from '../img/marly.png';
import matas from '../img/matas.png';
import menu from '../img/menu.png';
import Screenshot_1 from '../img/Screenshot_1.jpg';
import vale from '../img/vale.JPG';
import vale_png from '../img/vale.png';
import video_yoga from '../img/video yoga.png';
import ximen from '../img/ximen.jpg';
import yutu from '../img/yutu.png';

import video from '../video/video_yoga.mp4';

export default {
    'face': face,
    'fondo1': fondo1,
    'fondo2': fondo2,
    'fundadoras': fundadoras,
    'hatha': hatha,
    'hatha_yoga': hatha_yoga,
    'hero_image': hero_image,
    'hero_image_png': hero_image_png,
    'hero_image2': hero_image2,
    'instag': instag,
    'kundalini': kundalini,
    'kundalini2': kundalini2,
    'logo': logo,
    'maria': maria ,
    'maria_png': maria_png,
    'marly': marly,
    'marly_png': marly_png,
    'matas': matas,
    'menu': menu,
    'Screenshot_1': Screenshot_1,
    'vale': vale,
    'vale_png': vale_png,
    'video_yoga': video_yoga,
    'ximen': ximen,
    'yutu': yutu,
    'video': video
}